import diagnosticsService from "@/webapi/api/diagnostics_service"
import configurationService from "@/webapi/api/configuration_service"

export default {
  diagnosticsService,
  configurationService,
};
